export default "__VITE_ASSET__Cn0rvThf__"